module.exports = __webpack_public_path__ + "static/media/woman_desktop.0a2961d3.png";